/**
 * getQueryParamsFromString - Given a url containing query parameters,
 * it will return only the query parameters as a string. Optionally takes an includeOnlyList array
 * that will only return matchingQueryParams or a default empty string
 *
 * @param  {string} url - url to extract query parameters from
 * @param  {array} includeOnlyList - optional array parameter used to filter query params included in the array
 * @return {string} - properly formatted query parameters or defaults to an empty string
 */

export default function getQueryParamsFromString(url, includeOnlyList) {
    if (typeof url === 'string' && url.split('?').length > 1) {
      const queryParams = url.split('?')[1];

      if (!queryParams || queryParams.trim() === '') {
          return '';
      }

      // Handle the optional includeOnlyList array
      if (includeOnlyList && Array.isArray(includeOnlyList) && includeOnlyList.length) {
          const matchingQueryParams = [];
          let sanitizedQueryParams = '';
          includeOnlyList.forEach((item, index) => {
              const queryParamName = item.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
              const regex = new RegExp('[\\?&]' + queryParamName + '=([^&#]*)');
              const result = regex.exec(queryParams);

              if (result && Array.isArray(result) && result[0]) {
                  matchingQueryParams.push(result[0].replace('&', '')); // remove prepended `&`
              }
          });

          if (matchingQueryParams.length === 1) {
              sanitizedQueryParams += matchingQueryParams.join('');
          } else if (matchingQueryParams.length > 1) {
              sanitizedQueryParams += matchingQueryParams.join('&');
          }

          return sanitizedQueryParams;
      }

      return queryParams;
    }

    return '';
};



// WEBPACK FOOTER //
// ./app/lib/format/getQueryParamsFromString.js